/** Traductions des libellés de facture par langue */
export type FactureLangue = "fr" | "en" | "de" | "es" | "it";

export const FACTURE_TRANSLATIONS: Record<
  FactureLangue,
  {
    facture_vente: string;
    emetteur: string;
    client_recepteur: string;
    date_emission: string;
    date_echeance: string;
    type_vente: string;
    mode_paiement: string;
    moyen_paiement: string;
    ref: string;
    designation: string;
    qte: string;
    unite: string;
    pu_ht: string;
    total_ht: string;
    total_ttc: string;
    tva: string;
    autres_taxes: string;
    total_a_payer: string;
    resume_taxes: string;
    categorie: string;
    sous_total: string;
    taux: string;
    total_taxes: string;
    phrase_bas_page: string;
    a_partir_devis: string;
    facture_numerotee: string;
    fne: string;
    vente_biens: string;
    prestation_services: string;
    virement: string;
    cheque: string;
    especes: string;
    mobile_money: string;
    carte_bancaire: string;
    autre: string;
    produits: string;
    ajouter_ligne: string;
    choisir: string;
    ajouter_description: string;
    objet_facture: string;
    objet_avoir: string;
    paiement_sous_30j: string;
    parametres_complementaires: string;
    contenu: string;
    langue_label: string;
    langue_help: string;
    langue_help_avoir: string;
    conditions_paiement: string;
    delai_paiement: string;
    moyens_paiement_help: string;
    type_facture: string;
    type_facture_vente: string;
    type_facture_proforma: string;
    type_bordereau_achat: string;
  }
> = {
  fr: {
    facture_vente: "Facture de vente",
    emetteur: "Émetteur ou émettrice",
    client_recepteur: "Client / Récepteur",
    date_emission: "Date d'émission",
    date_echeance: "Date d'échéance",
    type_vente: "Type de vente",
    mode_paiement: "Mode de paiement",
    moyen_paiement: "Moyen de paiement",
    ref: "Réf",
    designation: "Désignation",
    qte: "Qté",
    unite: "Unité",
    pu_ht: "P.U HT",
    total_ht: "Total HT",
    total_ttc: "Total TTC",
    tva: "TVA",
    autres_taxes: "AUTRES TAXES",
    total_a_payer: "TOTAL À PAYER",
    resume_taxes: "RÉSUMÉ DES TAXES",
    categorie: "Catégorie",
    sous_total: "Sous-total",
    taux: "Taux",
    total_taxes: "Total taxes",
    phrase_bas_page: "Phrase bas de page",
    a_partir_devis: "À partir du devis N°",
    facture_numerotee: "Facture de vente N°",
    fne: "Facture normalisée électronique",
    vente_biens: "Vente de biens",
    prestation_services: "Prestation de services",
    virement: "Virement",
    cheque: "Chèque",
    especes: "Espèces",
    mobile_money: "Mobile-Money",
    carte_bancaire: "Carte bancaire",
    autre: "Autre",
    produits: "Produits",
    ajouter_ligne: "Ajouter une ligne",
    choisir: "Choisir...",
    ajouter_description: "Ajouter une description",
    objet_facture: "Objet de la facture",
    objet_avoir: "Objet de l'avoir",
    paiement_sous_30j: "Paiement sous 30 jours",
    parametres_complementaires: "Paramètres complémentaires",
    contenu: "Contenu",
    langue_label: "Langue",
    langue_help: "Sélectionnez la langue du document. Tous les libellés de la facture seront traduits.",
    langue_help_avoir: "Sélectionnez la langue du document. Tous les libellés de l'avoir seront traduits.",
    conditions_paiement: "Conditions de paiement",
    delai_paiement: "Délai de paiement",
    moyens_paiement_help: "Cochez les moyens acceptés. Un cadre sera affiché sur la facture.",
    type_facture: "Type facture",
    type_facture_vente: "Facture de vente",
    type_facture_proforma: "Facture proforma",
    type_bordereau_achat: "Bordereau d'achat produits agricole",
  },
  en: {
    facture_vente: "Sales invoice",
    emetteur: "Issuer",
    client_recepteur: "Client / Recipient",
    date_emission: "Issue date",
    date_echeance: "Due date",
    type_vente: "Type of sale",
    mode_paiement: "Payment method",
    moyen_paiement: "Payment method",
    ref: "Ref",
    designation: "Description",
    qte: "Qty",
    unite: "Unit",
    pu_ht: "Unit price excl. tax",
    total_ht: "Total excl. tax",
    total_ttc: "Total incl. tax",
    tva: "VAT",
    autres_taxes: "OTHER TAXES",
    total_a_payer: "TOTAL TO PAY",
    resume_taxes: "TAX SUMMARY",
    categorie: "Category",
    sous_total: "Subtotal",
    taux: "Rate",
    total_taxes: "Total taxes",
    phrase_bas_page: "Footer text",
    a_partir_devis: "Based on quote No.",
    facture_numerotee: "Sales invoice No.",
    fne: "Electronic standardized invoice",
    vente_biens: "Sale of goods",
    prestation_services: "Service provision",
    virement: "Bank transfer",
    cheque: "Cheque",
    especes: "Cash",
    mobile_money: "Mobile money",
    carte_bancaire: "Credit card",
    autre: "Other",
    produits: "Products",
    ajouter_ligne: "Add a line",
    choisir: "Choose...",
    ajouter_description: "Add a description",
    objet_facture: "Invoice subject",
    objet_avoir: "Credit note subject",
    paiement_sous_30j: "Payment within 30 days",
    parametres_complementaires: "Additional settings",
    contenu: "Content",
    langue_label: "Language",
    langue_help: "Select the document language. All invoice labels will be translated.",
    langue_help_avoir: "Select the document language. All credit note labels will be translated.",
    conditions_paiement: "Payment terms",
    delai_paiement: "Payment delay",
    moyens_paiement_help: "Tick the accepted payment methods. A box will be displayed on the invoice.",
    type_facture: "Invoice type",
    type_facture_vente: "Sales invoice",
    type_facture_proforma: "Proforma invoice",
    type_bordereau_achat: "Agricultural products purchase slip",
  },
  de: {
    facture_vente: "Verkaufsrechnung",
    emetteur: "Aussteller",
    client_recepteur: "Kunde / Empfänger",
    date_emission: "Ausstellungsdatum",
    date_echeance: "Fälligkeitsdatum",
    type_vente: "Verkaufsart",
    mode_paiement: "Zahlungsart",
    moyen_paiement: "Zahlungsmittel",
    ref: "Ref",
    designation: "Bezeichnung",
    qte: "Menge",
    unite: "Einheit",
    pu_ht: "Einh. Nettopreis",
    total_ht: "Gesamt Netto",
    total_ttc: "Gesamt Brutto",
    tva: "MwSt",
    autres_taxes: "ANDERE STEUERN",
    total_a_payer: "GESAMT ZU ZAHLEN",
    resume_taxes: "STEUERÜBERSICHT",
    categorie: "Kategorie",
    sous_total: "Zwischensumme",
    taux: "Satz",
    total_taxes: "Steuergesamt",
    phrase_bas_page: "Fußzeile",
    a_partir_devis: "Basierend auf Angebot Nr.",
    facture_numerotee: "Verkaufsrechnung Nr.",
    fne: "Elektronische Standardrechnung",
    vente_biens: "Warenverkauf",
    prestation_services: "Dienstleistung",
    virement: "Überweisung",
    cheque: "Scheck",
    especes: "Bar",
    mobile_money: "Mobile Money",
    carte_bancaire: "Kreditkarte",
    autre: "Sonstige",
    produits: "Produkte",
    ajouter_ligne: "Zeile hinzufügen",
    choisir: "Wählen...",
    ajouter_description: "Beschreibung hinzufügen",
    objet_facture: "Rechnungsgegenstand",
    objet_avoir: "Gegenstand der Gutschrift",
    paiement_sous_30j: "Zahlung innerhalb von 30 Tagen",
    parametres_complementaires: "Zusätzliche Einstellungen",
    contenu: "Inhalt",
    langue_label: "Sprache",
    langue_help: "Wählen Sie die Dokumentensprache. Alle Rechnungsbezeichnungen werden übersetzt.",
    langue_help_avoir: "Wählen Sie die Dokumentensprache. Alle Bezeichnungen der Gutschrift werden übersetzt.",
    conditions_paiement: "Zahlungsbedingungen",
    delai_paiement: "Zahlungsfrist",
    moyens_paiement_help: "Aktivieren Sie die akzeptierten Zahlungsarten. Ein Kasten wird auf der Rechnung angezeigt.",
    type_facture: "Rechnungstyp",
    type_facture_vente: "Verkaufsrechnung",
    type_facture_proforma: "Proformarechnung",
    type_bordereau_achat: "Landwirtschaftlicher Wareneinkaufsbeleg",
  },
  es: {
    facture_vente: "Factura de venta",
    emetteur: "Emisor",
    client_recepteur: "Cliente / Destinatario",
    date_emission: "Fecha de emisión",
    date_echeance: "Fecha de vencimiento",
    type_vente: "Tipo de venta",
    mode_paiement: "Método de pago",
    moyen_paiement: "Medio de pago",
    ref: "Ref",
    designation: "Designación",
    qte: "Cant",
    unite: "Unidad",
    pu_ht: "P.U sin IVA",
    total_ht: "Total sin IVA",
    total_ttc: "Total con IVA",
    tva: "IVA",
    autres_taxes: "OTROS IMPUESTOS",
    total_a_payer: "TOTAL A PAGAR",
    resume_taxes: "RESUMEN DE IMPUESTOS",
    categorie: "Categoría",
    sous_total: "Subtotal",
    taux: "Tipo",
    total_taxes: "Total impuestos",
    phrase_bas_page: "Pie de página",
    a_partir_devis: "A partir del presupuesto N°",
    facture_numerotee: "Factura de venta N°",
    fne: "Factura electrónica normalizada",
    vente_biens: "Venta de bienes",
    prestation_services: "Prestación de servicios",
    virement: "Transferencia",
    cheque: "Cheque",
    especes: "Efectivo",
    mobile_money: "Dinero móvil",
    carte_bancaire: "Tarjeta bancaria",
    autre: "Otro",
    produits: "Productos",
    ajouter_ligne: "Añadir una línea",
    choisir: "Elegir...",
    ajouter_description: "Añadir una descripción",
    objet_facture: "Objeto de la factura",
    objet_avoir: "Objeto de la nota de crédito",
    paiement_sous_30j: "Pago a 30 días",
    parametres_complementaires: "Parámetros complementarios",
    contenu: "Contenido",
    langue_label: "Idioma",
    langue_help: "Seleccione el idioma del documento. Todas las etiquetas de la factura se traducirán.",
    langue_help_avoir: "Seleccione el idioma del documento. Todas las etiquetas de la nota de crédito se traducirán.",
    conditions_paiement: "Condiciones de pago",
    delai_paiement: "Plazo de pago",
    moyens_paiement_help: "Marque los medios aceptados. Se mostrará un recuadro en la factura.",
    type_facture: "Tipo de factura",
    type_facture_vente: "Factura de venta",
    type_facture_proforma: "Factura proforma",
    type_bordereau_achat: "Albarán de compra productos agrícolas",
  },
  it: {
    facture_vente: "Fattura di vendita",
    emetteur: "Emittente",
    client_recepteur: "Cliente / Destinatario",
    date_emission: "Data di emissione",
    date_echeance: "Data di scadenza",
    type_vente: "Tipo di vendita",
    mode_paiement: "Metodo di pagamento",
    moyen_paiement: "Mezzo di pagamento",
    ref: "Rif",
    designation: "Descrizione",
    qte: "Qtà",
    unite: "Unità",
    pu_ht: "P.U lordo",
    total_ht: "Totale lordo",
    total_ttc: "Totale netto",
    tva: "IVA",
    autres_taxes: "ALTRE TASSE",
    total_a_payer: "TOTALE DA PAGARE",
    resume_taxes: "RIEPILOGO TASSE",
    categorie: "Categoria",
    sous_total: "Subtotale",
    taux: "Aliquota",
    total_taxes: "Totale tasse",
    phrase_bas_page: "Testo a piè di pagina",
    a_partir_devis: "In base al preventivo N°",
    facture_numerotee: "Fattura di vendita N°",
    fne: "Fattura elettronica standardizzata",
    vente_biens: "Vendita di beni",
    prestation_services: "Prestazione di servizi",
    virement: "Bonifico",
    cheque: "Assegno",
    especes: "Contanti",
    mobile_money: "Mobile money",
    carte_bancaire: "Carta di credito",
    autre: "Altro",
    produits: "Prodotti",
    ajouter_ligne: "Aggiungi una riga",
    choisir: "Scegli...",
    ajouter_description: "Aggiungi una descrizione",
    objet_facture: "Oggetto della fattura",
    objet_avoir: "Oggetto della nota di credito",
    paiement_sous_30j: "Pagamento entro 30 giorni",
    parametres_complementaires: "Parametri complementari",
    contenu: "Contenuto",
    langue_label: "Lingua",
    langue_help: "Seleziona la lingua del documento. Tutte le etichette della fattura saranno tradotte.",
    langue_help_avoir: "Seleziona la lingua del documento. Tutte le etichette della nota di credito saranno tradotte.",
    conditions_paiement: "Condizioni di pagamento",
    delai_paiement: "Termine di pagamento",
    moyens_paiement_help: "Selezionare i mezzi accettati. Una casella sarà visualizzata sulla fattura.",
    type_facture: "Tipo fattura",
    type_facture_vente: "Fattura di vendita",
    type_facture_proforma: "Fattura proforma",
    type_bordereau_achat: "Bordereau d'acquisto prodotti agricoli",
  },
};

export const LANGUE_OPTIONS: { value: FactureLangue; label: string }[] = [
  { value: "fr", label: "Français" },
  { value: "en", label: "English" },
  { value: "de", label: "Deutsch" },
  { value: "es", label: "Español" },
  { value: "it", label: "Italiano" },
];

export const MOYENS_PAIEMENT_IDS = ["Virement", "Carte bancaire", "Chèque", "Espèces", "Mobile-Money"] as const;
export type MoyenPaiementId = (typeof MOYENS_PAIEMENT_IDS)[number];

const MOYEN_TO_I18N_KEY: Record<string, keyof (typeof FACTURE_TRANSLATIONS)["fr"]> = {
  Virement: "virement",
  "Carte bancaire": "carte_bancaire",
  Chèque: "cheque",
  Espèces: "especes",
  "Mobile-Money": "mobile_money",
  Autre: "autre",
};

export function getMoyenPaiementLabel(moyen: string, t: (typeof FACTURE_TRANSLATIONS)["fr"]): string {
  return (t[MOYEN_TO_I18N_KEY[moyen]] as string) || moyen;
}
